import React, {RefObject} from 'react';
import {useTranslation} from 'react-i18next';
import Accessibility from '../../../../assets/icons/Accessibility';
import {ACCESSIBLE_COLOR} from '../../../../config/config';
import EventDateTime from '../../components/EventDateTime/EventDateTime';
import TicketQr from '../../components/TicketQr/TicketQr';
import {TEticketEvent, TEticketSeat} from '../../../../redux/eTicket/eTicket.type';
import * as css from './TicketDetailsBody.css';
import {WHITE} from '../../../../globalVariables/GlobalVariables';

interface TicketDetailsBodyProps {
    event: TEticketEvent;
    ticket: {title: string; barcode: string; qid: number, color: string, seat?: TEticketSeat};
    index: number;
    total: number;
    cardQrRef: RefObject<HTMLDivElement>;
    isScanning: boolean;
    reduceMotion: boolean | null;
    onQrZoom: () => void;
}

function TicketDetailsBody({
    event,
    ticket,
    index,
    total,
    cardQrRef,
    isScanning,
    reduceMotion,
    onQrZoom,
}: TicketDetailsBodyProps) {
    const {t} = useTranslation('eTicket');
    const isAccessible = ticket.color === ACCESSIBLE_COLOR;

    return (
        <css.body>
            <css.title>{event.title}</css.title>
            {ticket.title && (
                <css.ticketName $accessible={isAccessible} data-cy="ticket-name">
                    {isAccessible && (
                        <css.a11yIcon aria-hidden>
                            <Accessibility color={WHITE} />
                        </css.a11yIcon>
                    )}
                    <css.ticketNameText>{ticket.title}</css.ticketNameText>
                </css.ticketName>
            )}
            {ticket.seat && (ticket.seat.section || ticket.seat.row || ticket.seat.seat) && (
                <css.seatInfo data-cy="ticket-seat">
                    {ticket.seat.section && (
                        <css.seatPart>
                            <css.seatPartLabel>{t('seatSection')}</css.seatPartLabel>
                            <css.seatPartValue>{ticket.seat.section}</css.seatPartValue>
                        </css.seatPart>
                    )}
                    {ticket.seat.row && (
                        <css.seatPart>
                            <css.seatPartLabel>{t('seatRow')}</css.seatPartLabel>
                            <css.seatPartValue>{ticket.seat.row}</css.seatPartValue>
                        </css.seatPart>
                    )}
                    {ticket.seat.seat && (
                        <css.seatPart>
                            <css.seatPartLabel>{t('seatNumber')}</css.seatPartLabel>
                            <css.seatPartValue>{ticket.seat.seat}</css.seatPartValue>
                        </css.seatPart>
                    )}
                </css.seatInfo>
            )}
            <EventDateTime event={event} />
            <TicketQr
                barcode={ticket.barcode}
                qrWrapRef={cardQrRef}
                isScanning={isScanning}
                reduceMotion={reduceMotion}
                onZoom={onQrZoom}
            />
            <css.ticketNo data-cy="ticket-counter">
                {t('ticketCounter', {current: index + 1, total})}
                {' • '} {ticket.qid}
            </css.ticketNo>
        </css.body>
    );
}

export default TicketDetailsBody;
